import React from "react";

import { Card, CardContent, Grid } from "@material-ui/core";

import { SERVICE_TYPES } from "../../../config/constants";
import { PlasticBagconfigurationViewUtils, ServiceActiveFlagViewUtils } from "../CountrySettingView";
import { ADVANCE_DAYS_DDN_OPTIONS, COUNTRY_SETTING_TEXT_CONSTANT, MinuteBasedConfigInterface } from "../CountrySettingsUtils";

import RenderAdvanceSlotDays from "./RenderAdvanceSlotDays";
import RadioGroupField from "components/common/RadioGroupField/RadioGroupField";
import { ON_OFF_OPTIONS } from "components/common/App/app-constant";

interface RenderExpressServiceTypeDetailsInterface {
  classes: any;
  expressDetails: MinuteBasedConfigInterface;
  handleExpressDetailsChange: any;
  handleBagChargeChange: any;
  handleAdvanceDaysClick: any;
  handleServiceTypeActiveChange: (event: React.ChangeEvent<HTMLInputElement>, serviceTypeName: string) => void;
  handlePlasticBagChange: (event: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  handleEditBagCharges: (name: string) => void;
  serviceTypeName: string;
}

const RenderExpressServiceTypeDetails = (props: RenderExpressServiceTypeDetailsInterface) => {
  const { classes, expressDetails, serviceTypeName, handleExpressDetailsChange, handleBagChargeChange, handleAdvanceDaysClick, handleServiceTypeActiveChange, handlePlasticBagChange, handleEditBagCharges } = props;
  return (
    <Card className={classes.serviceTypeCard}>
      <CardContent>
        <Grid container justifyContent="flex-start" spacing={1}>
          <ServiceActiveFlagViewUtils
            classes={classes}
            serviceTypeName={serviceTypeName}
            serviceActiveFlag={expressDetails.serviceActive}
            isDisabled={false}
            handleServiceTypeActiveChange={handleServiceTypeActiveChange}
          />
          <RadioGroupField
            title={COUNTRY_SETTING_TEXT_CONSTANT.NEXT_DAY_SLOT_VISIBILITY}
            name="expressNextDaySlotVisibility"
            value={expressDetails.nextDaySlotVisibility}
            options={ON_OFF_OPTIONS}
            disabled // This entire group is disabled
            classes={classes}
            xs={2}
          />
          <PlasticBagconfigurationViewUtils
            classes={classes}
            bagChargeEnabled={expressDetails.bagChargeEnabled}
            handleBagChargeChange={handleBagChargeChange}
            name={serviceTypeName ?? SERVICE_TYPES.EXPRESS}
            itemsPerBag={expressDetails.itemsPerBag}
            bagCharges={expressDetails.bagCharges}
            editBagCharge={expressDetails.editBagCharge}
            handlePlasticBagChange={handlePlasticBagChange}
            handleEditBagCharges={handleEditBagCharges}
            newPlasticBagCharges={expressDetails.newPlasticBagCharges}
          />
          <RenderAdvanceSlotDays
            classes={classes}
            advanceSlotDays={expressDetails.advanceSlotDays}
            showAdvanceSlotDaysInput={expressDetails.showAdvanceSlotDaysInput}
            menuItems={ADVANCE_DAYS_DDN_OPTIONS}
            name={"expressAdvanceSlotDays"}
            value={expressDetails.editSlotDays || expressDetails.advanceSlotDays}
            handleChange={handleExpressDetailsChange}
            handleAdvanceDaysClick={handleAdvanceDaysClick}
            serviceTypeName={serviceTypeName}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default React.memo(RenderExpressServiceTypeDetails);
